export enum CardActivityType {
  NOT_INSERTED = 'NOT_INSERTED',
  INSERTED = 'INSERTED',
}
